// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import {
  MarketingDiv,
  HeaderBlockP,
  MarketingNavTabsDiv
} from './MarketingStyle';
import HeaderBlock from '../../components/HeaderBlock';
import { MarketingBody } from './MarketingBody';
import {
  loadMarketingFiles,
  setSalesMaterialFilter,
  downloadFile
} from './reducer';
import PageLoader from '../../components/PageLoader';
import NavTabs from '../../components/NavTabs';
import { TabNavLink, SpacerTab } from '../../components/TabStyles';
import MarketingCollateral from './MarketingCollateral';
import SalesMaterial from './SalesMaterial';
import { Default } from '../../components/Responsive';

export type MarketingFile = {
  name: string,
  url: string,
  file_type: string,
  category:
    | 'sales_material'
    | 'brand_assets'
    | 'crypto_badge'
    | 'partners_collateral',
  description: ?string
};

type Props = {
  marketingFiles: MarketingFile[],
  brandAssetsFiles: MarketingFile[],
  cryptoBadgeFiles: MarketingFile[],
  marketingCollateral: MarketingFile[],
  customSalesMaterialFiles: MarketingFile[],
  salesVideos: MarketingFile[],
  loadMarketingFiles: () => void,
  loading: boolean,
  salesMaterialMerchants: MarketingFile[],
  salesMaterialPartners: MarketingFile[],
  salesMaterialFilter: string,
  setSalesMaterialFilter: (salesMaterialCategory: ?string) => void,
  downloadFile: (url: string, fileName: string) => void
};

class Marketing extends Component<Props> {
  componentDidMount() {
    this.props.loadMarketingFiles();
  }
  render() {
    if (this.props.loading) {
      return <PageLoader />;
    }
    return (
      <MarketingDiv>
        <HeaderBlock title="Marketing">
          <HeaderBlockP>
            Download our official, up-to-date marketing materials to use for
            explaining the NetCents platform to potential merchants and
            partners.
          </HeaderBlockP>
        </HeaderBlock>
        <MarketingNavTabsDiv>
          <NavTabs>
            <TabNavLink to="/marketing/sales-materials">
              Sales Material
            </TabNavLink>
            <TabNavLink exact to="/marketing/crypto-badge">
              Marketing
              <Default> Collateral</Default>
            </TabNavLink>
            <TabNavLink exact to="/marketing/brand-assets">
              <Default>Brand </Default>
              Assets
            </TabNavLink>
            <SpacerTab tablet />
          </NavTabs>
        </MarketingNavTabsDiv>
        <Switch>
          <Route
            exact
            path="/marketing/brand-assets"
            render={props => (
              <MarketingBody
                {...props}
                marketingFiles={this.props.brandAssetsFiles}
                downloadFile={this.props.downloadFile}
              />
            )}
          />
          <Route
            exact
            path="/marketing/crypto-badge"
            render={props => (
              <MarketingCollateral
                {...props}
                marketingFiles={this.props.cryptoBadgeFiles}
                marketingCollateral={this.props.marketingCollateral}
              />
            )}
          />
          <Route
            // exact
            path="/marketing/sales-materials"
            render={props => (
              <SalesMaterial
                {...props}
                salesMaterialMerchants={this.props.salesMaterialMerchants}
                salesMaterialPartners={this.props.salesMaterialPartners}
                customSalesMaterials={this.props.customSalesMaterialFiles}
                salesMaterialFilter={this.props.salesMaterialFilter}
                setSalesMaterialFilter={this.props.setSalesMaterialFilter}
                salesVideos={this.props.salesVideos}
                downloadFile={this.props.downloadFile}
              />
            )}
          />
        </Switch>
      </MarketingDiv>
    );
  }
}

const mapStateToProps = state => ({
  brandAssetsFiles: state.marketing.marketingFiles.filter(
    file => file.category === 'brand_assets'
  ),
  cryptoBadgeFiles: state.marketing.marketingFiles.filter(
    file => file.category === 'crypto_badge'
  ),
  marketingCollateral: state.marketing.marketingFiles.filter(
    file => file.category === 'partners_collateral'
  ),
  salesMaterialMerchants: state.marketing.marketingFiles.filter(
    file =>
      file.category &&
      file.category.startsWith('sales_material_merchants') &&
      !file.category.endsWith('sales_videos') &&
      !file.category.endsWith('demo_videos')
  ),
  salesMaterialPartners: state.marketing.marketingFiles.filter(
    file =>
      file.category &&
      file.category.startsWith('sales_material_partners') &&
      !file.category.endsWith('sales_videos') &&
      !file.category.endsWith('demo_videos')
  ),
  salesVideos: state.marketing.marketingFiles.filter(
    file =>
      (file.category && file.category.endsWith('sales_videos')) ||
      (file.category && file.category.endsWith('demo_videos'))
  ),
  customSalesMaterialFiles: state.marketing.customMarketingFiles,
  loading: state.marketing.loading,
  salesMaterialFilter: state.marketing.salesMaterialFilter
});

const mapDispatchToProps = {
  loadMarketingFiles,
  setSalesMaterialFilter,
  downloadFile
};

export default connect(mapStateToProps, mapDispatchToProps)(Marketing);
